var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('shop-view',{attrs:{"shop":_vm.shop}})],1),_c('v-flex',{attrs:{"xs6":""}},[_c('shop-form',{attrs:{"shop":_vm.shop},on:{"onMessage":_vm.onMessage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }